import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({
  title,
  description,
  appleTouchIcon,
  favIcon,
  keywords,
  logo,
}) => {
  return (
    <>
      <Helmet>
        <title>{`${
          title ||
          global.site_name ||
          `Find the best real estate auctions with ${
            global.site_name || "Next Door Auctions"
          }`
        }`}</title>
        <link rel="icon" id="favicon" href={favIcon} />
        <meta
          name="title"
          content={`${
            title ||
            global.site_name ||
            `Find the best real estate auctions with ${
              global.site_name || "Next Door Auctions"
            }`
          }`}
        />
        <meta
          name="description"
          content={`${
            description ||
            `Find the best real estate auctions with ${
              global.site_name || "Next Door Auctions"
            }. Discover top property auctions with Next Door Auctions, Discover top property deals, bid on foreclosed homes, and explore investment opportunities. Start bidding today!`
          }`}
        />
        <link rel="apple-touch-icon" href={appleTouchIcon} />
        <meta
          name="keywords"
          content={`${keywords}, Find the best real estate auctions - Next Door Auctions, Discover top property auctions with Next Door Auctions, Next Door Auctions, Next Door Auctions real estate auctions,real estate,real estate bidding, bid on real estate auctions,  bid on foreclosed homes, real estate auction homes for sale,top property deals, top property auctions, Exclusive foreclosure and bank-owned auction properties, real estate auctions for foreclosures, best real estate auctions, houses to buy, foreclosures near me, foreclosed homes near me, foreclosed homes for sale, foreclosed houses near me, new houses for sale near me, best online real estate auction sites, best website for auction homes, top real estate auction sites, top real estate auction websites, best property auctions, best auction property websites, best online home auction sites, best auction property websites, best online home auction sites, best online property auctions homes, best real estate auction companies, top home auction sites, property auctions, real estate auctions, Next Door Auctions real estate auctions,Real Estate Auction,  Real Estate Auctioneer, Real Estate Auction Company, Real Estate Auction Services, Property Auction, Foreclosures, Estate Auctions, Bank Auctions, Commercial Property Auction, Residential Property Auction, Investment Property Auction, Home Auctions, Waterfront Property Auction, Real Estate for Sale, Multi-Family Property, Luxury Home Auctions, Foreclosure Auctions, Public Auctions,  Condominium Auction, Auctioneer, Auctions, real estate auctions near me`}
        />
        <meta
          name="og:title"
          property="og:title"
          content={`${title || global.site_name || "Next Door Auctions"}`}
        />
        <meta
          name="og:description"
          property="og:description"
          content={`${
            description ||
            `Find the best real estate auctions with ${
              global.site_name || "Next Door Auctions"
            }. Discover top property deals, bid on foreclosed homes, and explore investment opportunities. Start bidding today!`
          }`}
        />
        <link rel="canonical" href={window?.location?.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${title || global.site_name || "Next Door Auctions"}`}
        />
        <meta
          name="twitter:description"
          content={`${
            description ||
            `Find the best real estate auctions with ${
              global.site_name || "Next Door Auctions"
            }. Discover top property deals, bid on foreclosed homes, and explore investment opportunities. Start bidding today!`
          }`}
        />
        <meta property="og:url" content="https://nextdoorauctions.com" />
        <meta name="og:image:alt" property="og:image:alt" content={logo} />
        <meta property="og:image" content={logo} />
        <meta property="og:image:secure_url" content={logo} />
        <meta property="og:image:width" content="400" />
        <meta property="og:image:height" content="300" />
      </Helmet>
    </>
  );
};

export default SEO;
